import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Job } from './job';

export interface JobsCollection {
  getJobs(): Observable<Job[]>;
  addJob(job: Job): Promise<unknown>;
  editJob(job: Job): Promise<void>;
  deleteJob(job: Job): Promise<void>;
}

export const JOBS_COLLECTION = new InjectionToken<JobsCollection>(
  'JOBS_COLLECTION',
);
